import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { QuoteDTO } from 'views/types';

const baseUrl = '/api/v1/';
// const baseUrl = 'https://payment.cryptopay-dev.space-app.io/api/v1/';
const tags = ['TopUps', 'PaymentGateway'];

export const topupsApi = createApi({
  reducerPath: 'topupsApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
  }),
  tagTypes: tags,
  endpoints: (builder) => ({
    postPaymentIntentRefundQuote: builder.mutation<QuoteDTO, { authToken: string }>({
      invalidatesTags: ['PaymentGateway'],
      query: ({ authToken }) => ({
        url: `payment-intents/top-ups/quote-request`,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }),
    }),
    getTopUpLink: builder.query<string, { authToken: string; languageIso2?: string }>({
      query: ({ authToken, languageIso2 }) => ({
        url: `payment-intents/top-ups/link${languageIso2 ? `?languageIso2=${languageIso2}` : ''}`,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }),
    }),
  }),
});

export const { usePostPaymentIntentRefundQuoteMutation, useLazyGetTopUpLinkQuery } = topupsApi;
